import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const Root = styled.div<{ show: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  animation: ${({ show }) => `${show ? 'fadeIn' : 'fadeOut'} 300ms, ${show ? 'zoomIn' : 'zoomOut'} 300ms`};
`;

const FadeTransition: React.FC<{ children: React.ReactNode; show: boolean }> = ({ show, children }) => {
  const [render, setRender] = useState(show);

  useEffect(() => {
    if (show) {
      setRender(true);
    }
  }, [show]);

  const onAnimationEnd = () => {
    if (!show) {
      setRender(false);
    }
  };

  return render ? (
    <Root onAnimationEnd={onAnimationEnd} show={show}>
      {children}
    </Root>
  ) : null;
};

export default FadeTransition;
